var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_91875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 6.80779V10.1411M10.4999 13.4745H10.5082M9.0749 2.52445L2.01656 14.3078C1.87104 14.5598 1.79403 14.8455 1.79322 15.1366C1.7924 15.4276 1.8678 15.7137 2.01192 15.9666C2.15603 16.2194 2.36383 16.4301 2.61465 16.5777C2.86547 16.7252 3.15056 16.8046 3.44156 16.8078H17.5582C17.8492 16.8046 18.1343 16.7252 18.3851 16.5777C18.636 16.4301 18.8438 16.2194 18.9879 15.9666C19.132 15.7137 19.2074 15.4276 19.2066 15.1366C19.2058 14.8455 19.1288 14.5598 18.9832 14.3078L11.9249 2.52445C11.7763 2.27954 11.5672 2.07705 11.3176 1.93652C11.068 1.79599 10.7863 1.72217 10.4999 1.72217C10.2134 1.72217 9.93184 1.79599 9.68223 1.93652C9.43263 2.07705 9.22345 2.27954 9.0749 2.52445Z",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_91875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.141113)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAlert);
export default __webpack_public_path__ + "static/media/alert-alert.23c09bc8f63293ac21d5784566af076b.svg";
export { ForwardRef as ReactComponent };